import React from "react";
import { Box, IconButton, Typography, Paper, Button } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { removeItemFromCart, updateItemQuantity } from "../../redux/Slices/Cart";
import { cartItemKey, formatMoney, unitPrice } from "../../utils/cartPricing";
import fallbackImage from "../../shared/images/no-image.jpg";

export default function CartTable() {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.cartSlice.items);
  if (!items.length) return <p>Din varukorg är tom.</p>;
  return <Paper sx={{ p: 2 }}>
    {items.map((item) => <Box key={cartItemKey(item)} sx={{
      display: "flex", alignItems: "center", gap: 2, py: 2, flexWrap: "wrap",
      borderBottom: "1px solid #eee", "&:last-child": { borderBottom: 0 },
    }}>
      <Link to={"/product/" + item.productId} tabIndex={-1} aria-hidden="true">
        <img src={item.imageUrl || fallbackImage} alt="" width={60} height={60} style={{ objectFit: "contain" }} />
      </Link>
      <Typography component={Link} to={"/product/" + item.productId}
        sx={{ flex: "1 1 160px", minWidth: 0, color: "#333", overflowWrap: "anywhere" }}>
        {item.name || "Produkt"}{item.unavailable && <span style={{ display: "block", color: "#9c3b12" }}>Inte tillgänglig i valt antal</span>}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <IconButton aria-label={"Minska antal " + item.name} disabled={item.quantity <= 1}
          onClick={() => dispatch(updateItemQuantity({ ...item, quantity: item.quantity - 1 }))}><RemoveIcon /></IconButton>
        <Typography sx={{ mx: 1 }} aria-label={"Antal: " + item.quantity}>{item.quantity}</Typography>
        <IconButton aria-label={"Öka antal " + item.name} disabled={item.stock != null && item.quantity >= item.stock}
          onClick={() => dispatch(updateItemQuantity({ ...item, quantity: item.quantity + 1 }))}><AddIcon /></IconButton>
      </Box>
      <Typography sx={{ fontWeight: 600 }}>{formatMoney(unitPrice(item))} / st</Typography>
      <Button onClick={() => dispatch(removeItemFromCart(item))} aria-label={"Ta bort " + item.name}>Ta bort</Button>
    </Box>)}
  </Paper>;
}
